// src/components/ui/forms/FormButton/FormButtonShadcn.jsx
import React from 'react';

// shadcn components
import { Button } from '../../button';
import { Spinner } from '../../spinner';

import { cn } from '../../../../utils/cn';

const FormButtonShadcn = ({
  children,
  type = 'button',
  variant = 'primary', // 'primary', 'secondary', 'ghost'
  size = 'default', // 'sm', 'default', 'lg'
  disabled = false,
  loading = false,
  className = '',
  ...props
}) => {
  // Map our custom variants to shadcn variants
  const getShadcnVariant = () => {
    if (variant === 'ghost') return 'ghost';
    if (variant === 'secondary') return 'ghost'; // Use ghost for secondary
    return 'default'; // primary uses default
  };

  // Custom styling for primary gradient button
  const isPrimary = variant === 'primary';

  return (
    <Button
      type={type}
      variant={getShadcnVariant()}
      size={size}
      disabled={disabled || loading}
      className={cn(
        // Primary variant gets gradient styling
        isPrimary && [
          "bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium",
          "hover:from-blue-700 hover:to-purple-700",
          "disabled:from-slate-700 disabled:to-slate-600"
        ],

        // Secondary variant styling
        variant === 'secondary' && [
          "text-slate-400 font-medium hover:text-slate-200",
          "disabled:text-slate-500"
        ],

        // Ghost variant border
        variant === 'ghost' && [
          "border border-slate-600/50 hover:border-slate-500/50"
        ],

        className
      )}
      {...props}
    >
      {loading ? (
        <span className="flex items-center gap-2">
          <Spinner className="size-4" />
          {children}
        </span>
      ) : (
        children
      )}
    </Button>
  );
};

export default FormButtonShadcn;